'use client';

import { Accordion, Text, TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';

const optionsFilter = (options: any[], search: string) =>
  search
    ? options
        .filter((option) =>
          option.question.toLowerCase().trim().includes(search.toLowerCase().trim())
        )
        .sort((a, b) => a.question.localeCompare(b.question))
    : options;

export default function FaqAccordion({ faqs }: { faqs: any[] }) {
  const [value, setValue] = useState('');

  return (
    <>
      <TextInput
        mb="xs"
        type="search"
        placeholder="Search for a question"
        leftSectionPointerEvents="none"
        leftSection={<IconSearch size="1rem" />}
        value={value}
        onChange={(event) => setValue(event.currentTarget.value)}
      />
      <Accordion defaultValue={null}>
        {optionsFilter(faqs, value).map((faq) => (
          <Accordion.Item value={faq.question} key={faq.question}>
            <Accordion.Control>
              <Text fw={600}>{faq.question}</Text>
            </Accordion.Control>
            <Accordion.Panel>{faq.answer}</Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
}
